//import { injectMocks } from '@jfs/network'
import { UiThemeProvider } from '@jfs/ui-new'
import { RootStore, StoreProvider } from './data/store'
//import { mocks } from './mocks'
import { AppStack } from './nav/RootNav'
import { customTheme } from './utils/customTheme'

export const isFromMock = false

// if (isFromMock) {
//   injectMocks(mocks, 'default', undefined, sessionStorage.getItem('activeMocks') ?? undefined)
// }

const App = () => {
  // const mode = 'JIOMONEY'
  return (
    <UiThemeProvider
      initialThemeName="light"
      customTheme={{ name: 'billerLight', extraTheme: customTheme, extends: 'light' }}>
      <StoreProvider value={RootStore}>
        <AppStack />
      </StoreProvider>
    </UiThemeProvider>
  )
}

export { App }
